<template>
    <div>
        <h3>Content Management</h3>

        <b-input-group class="filter-group">
            <b-input-group-prepend is-text>
                <font-awesome-icon icon="search" />
            </b-input-group-prepend>
            <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
            <b-input-group-append>
                <b-button @click="filter = null">Clear</b-button>
            </b-input-group-append>

            <b-button :to="{ name: 'contentNew' }" class="new-content-button"><font-awesome-icon icon="plus" /> Add New Content</b-button>
        </b-input-group>

        <b-table striped
                 hover
                 :items="content"
                 :fields="fields"
                 :per-page="perPage"
                 :current-page="currentPage"
                 :sort-compare="customSort"
                 :filter="filter"
                 @filtered="onFiltered"
                 responsive>
          <template slot="preview" slot-scope="data">
            <div v-html="getDecodedHtml(data.item.preview)"></div>
          </template>
          <template slot="contentCategory" slot-scope="data">
            {{data.item.contentCategory.name}}
          </template>
          <template slot="contentType" slot-scope="data">
            {{data.item.contentType.name}}
          </template>
          <template slot="edit" slot-scope="data">
            <router-link :to="{ name: 'contentEditing', params: { id: data.item.id } }">Edit</router-link>
          </template>
        </b-table>
    </div>
</template>

<script>
var htmlDecode = require("js-htmlencode").htmlDecode;

export default {
  data() {
    return {
      fields: [
        { key: "name", sortable: true },
        { key: "title", sortable: true },
        { key: "preview" },
        { key: "contentCategory", sortable: true },
        { key: "contentType", sortable: true },
        { key: "edit" }
      ],
      currentPage: 1,
      perPage: 20,
      totalRows: 0,
      filter: null
    };
  },

  props: {
    content: {
      type: Array,
      required: true
    }
  },

  methods: {
    customSort(a, b, key) {
      if (key === "contentCategory") {
        var categoryNameA = a.contentCategory.name;
        var categoryNameB = b.contentCategory.name;
        return categoryNameA.localeCompare(categoryNameB);
      } else if (key === "contentType") {
        var typeNameA = a.contentType.name;
        var typeNameB = b.contentType.name;
        return typeNameA.localeCompare(typeNameB);
      } else {
        return null;
      }
    },

    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    getDecodedHtml(encodedString) {
      if (encodedString) {
        return htmlDecode(encodedString);
      }
      return "";
    }
  }
};
</script>

<style scoped>
.filter-group {
  margin: 10px 0 15px 0;
  max-width: 600px;
}

.new-content-button {
  margin-left: 10px;
}
</style>
